import { useState, useEffect } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import api from '../lib/api';

export default function CryptoTicker() {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const res = await api.get('/crypto/prices');
        setCoins(res.data);
      } catch { /* silent */ }
    };
    fetchPrices();
    const interval = setInterval(fetchPrices, 120000);
    return () => clearInterval(interval);
  }, []);

  if (!coins.length) return null;

  const fmt = (n) => {
    if (n >= 1000) return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
    if (n >= 1) return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(n);
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 4 }).format(n);
  };

  const doubled = [...coins, ...coins];

  return (
    <div className="w-full overflow-hidden bg-[#0D0E18] border-b border-[#2D2E3D]/50" data-testid="crypto-ticker">
      <div className="flex animate-scroll whitespace-nowrap py-2">
        {doubled.map((coin, i) => (
          <div key={`${coin.id}-${i}`} className="flex items-center gap-2 px-5 shrink-0">
            {coin.image && <img src={coin.image} alt={coin.symbol} className="w-4 h-4 rounded-full" />}
            <span className="text-xs font-semibold text-white">{coin.symbol}</span>
            <span className="text-xs font-mono text-[#94A3B8]">{fmt(coin.current_price)}</span>
            <span className={`text-xs font-mono flex items-center gap-0.5 ${coin.price_change_24h >= 0 ? 'text-[#10B981]' : 'text-[#EF4444]'}`}>
              {coin.price_change_24h >= 0 ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
              {coin.price_change_24h?.toFixed(1)}%
            </span>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
